<template>
  <button 
    class="hamburger"
    :class="{'open': isOpen}">
    <div>
      <span class="bar bar1"></span>
      <span class="bar bar2"></span>
      <span class="bar bar3"></span>
      <span class="bar bar4"></span>
    </div>
    <span class="sr-only">Menu</span>
  </button>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  }

}
</script>

<style>

</style>